import { useState } from 'react';
import type { CropMonitorRecord } from '@/types/api';
import ImageModal from '@/components/feature/ImageModal';

interface ImageGridProps {
  record: CropMonitorRecord;
}

const IMAGE_PANELS = [
  { key: 'rgb1_url' as const, label: 'RGB1', icon: 'ri-camera-line', color: '#2E86C1' },
  { key: 'rgb2_url' as const, label: 'RGB2', icon: 'ri-camera-2-line', color: '#8e44ad' },
  { key: 'nir_url' as const, label: 'NIR', icon: 'ri-infrared-thermometer-line', color: '#e67e22' },
  { key: 'tof_url' as const, label: 'ToF Depth', icon: 'ri-focus-3-line', color: '#16a085' },
];

export default function ImageGrid({ record }: ImageGridProps) {
  const [modal, setModal] = useState<{ url: string; label: string } | null>(null);

  return (
    <>
      <div className="grid grid-cols-2 gap-2 md:gap-3">
        {IMAGE_PANELS.map(panel => {
          const url = record[panel.key];
          return (
            <div
              key={panel.key}
              className="relative rounded-xl overflow-hidden cursor-pointer group"
              style={{ aspectRatio: '4/3', backgroundColor: '#0f1e2a' }}
              onClick={() => url && setModal({ url, label: panel.label })}
            >
              {url ? (
                <>
                  <img
                    src={url}
                    alt={panel.label}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-zoom-in-line text-gray-800 text-lg"></i>
                    </div>
                  </div>
                </>
              ) : (
                <div className="w-full h-full flex flex-col items-center justify-center text-gray-500">
                  <div className="w-10 h-10 flex items-center justify-center mb-1">
                    <i className="ri-image-line text-3xl"></i>
                  </div>
                  <span className="text-xs">이미지 없음</span>
                </div>
              )}
              {/* Label badge */}
              <div
                className="absolute top-2 left-2 flex items-center gap-1 px-2 py-1 rounded-lg text-white text-xs font-bold"
                style={{ backgroundColor: panel.color + 'cc' }}
              >
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className={`${panel.icon} text-xs`}></i>
                </div>
                {panel.label}
              </div>
            </div>
          );
        })}
      </div>

      {modal && (
        <ImageModal
          isOpen={true}
          imageUrl={modal.url}
          label={modal.label}
          onClose={() => setModal(null)}
        />
      )}
    </>
  );
}
